<template>
  <b-card>

    <b-row>
      <label class="custom-font mb-1"
      ><b>Attendance Summary : Today</b></label
    >

    <div class="button-style">
        <b-button
          class="flex-shrink-0 mr-1"
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          @click="goAttendance"
        >
        <feather-icon icon="ClipboardIcon" />
        </b-button>
      </div>
    </b-row>


    <div class="mb-1">

      <template v-if="attendanceStatusSummary?.present_info">
        <div>

          <b-badge
              variant="primary"
              class="mr-1 cursor-pointer"
              :class="filterWith === 'all' ? 'badge-glow': ''"
              v-b-tooltip.hover
              :title="'All'"
              @click="filterByStatus('all')"
          >
            All
          </b-badge>

          <b-badge
              :style="{ color: 'white', backgroundColor: ( attendanceStatusSummary?.present_info?.info?.color_code ?? '#7367f0' ) }"
            class=" mr-1 cursor-pointer"
              :class="filterWith === attendanceStatusSummary?.present_info?.info?.id ? 'badge-glow': ''"
            v-b-tooltip.hover
            :title="attendanceStatusSummary?.present_info?.info?.name"
            @click="filterByStatus(attendanceStatusSummary?.present_info?.info?.id)"
          >
            {{ attendanceStatusSummary?.present_info?.info?.sort_name }}
            {{ attendanceStatusSummary?.present_info?.count }}
          </b-badge>

          <b-badge
            :style="{ color: 'white', backgroundColor: ( attendanceStatusSummary?.leave_info?.info?.color_code ?? '#7367f0' ) }"
            class="mr-1 cursor-pointer"
            :class="filterWith === attendanceStatusSummary?.leave_info?.info?.id ? 'badge-glow': ''"
            v-b-tooltip.hover
            :title="attendanceStatusSummary?.leave_info?.info?.name"
            @click="filterByStatus(attendanceStatusSummary?.leave_info?.info?.id)"

          >
            {{ attendanceStatusSummary?.leave_info?.info?.sort_name }}
            {{ attendanceStatusSummary?.leave_info?.count }}
          </b-badge>
          <b-badge
              :style="{ color: 'white', backgroundColor: ( attendanceStatusSummary?.absent_info?.info?.color_code ?? '#7367f0' ) }"
              class="mr-1 cursor-pointer"
              :class="filterWith === attendanceStatusSummary?.absent_info?.info?.id ? 'badge-glow': ''"
            v-b-tooltip.hover
            :title="attendanceStatusSummary?.absent_info?.info?.name"
            @click="filterByStatus(attendanceStatusSummary?.absent_info?.info?.id)"

          >
            {{ attendanceStatusSummary?.absent_info?.info?.sort_name }}
            {{ attendanceStatusSummary?.absent_info?.count }}
          </b-badge>

          <b-badge
              :style="{ color: 'white', backgroundColor: ( attendanceStatusSummary?.delay_info?.info?.color_code ?? '#7367f0' ) }"
              class="mr-1 cursor-pointer"
              :class="filterWith === attendanceStatusSummary?.delay_info?.info?.id ? 'badge-glow': ''"
            v-b-tooltip.hover
            :title="attendanceStatusSummary?.delay_info?.info?.name"
            @click="filterByStatus(attendanceStatusSummary?.delay_info?.info?.id)"

          >
            {{ attendanceStatusSummary?.delay_info?.info?.sort_name }}
            {{ attendanceStatusSummary?.delay_info?.count }}
          </b-badge>

          <b-badge
              :style="{ color: 'white', backgroundColor: ( attendanceStatusSummary?.extreme_delay_info?.info?.color_code ?? '#7367f0' ) }"
              class="mr-1 cursor-pointer"
              :class="filterWith === attendanceStatusSummary?.extreme_delay_info?.info?.id ? 'badge-glow': ''"
            v-b-tooltip.hover
            :title="attendanceStatusSummary?.extreme_delay_info?.info?.name"
            @click="filterByStatus(attendanceStatusSummary?.extreme_delay_info?.info?.id)"

          >
            {{ attendanceStatusSummary?.extreme_delay_info?.info?.sort_name }}
            {{ attendanceStatusSummary?.extreme_delay_info?.count }}
          </b-badge>
        </div>
      </template>
      <template v-else>
        <div class="attendance-spinner-parent">
          <b-spinner variant="primary" />
        </div>
      </template>
    </div>

    <span v-if="isLoading" class="d-flex justify-content-center align-items-center">
        <b-spinner variant="primary"/>
      </span>

    <b-table v-else-if="items.length > 0 && !isLoading" responsive="sm" :fields="fields" :items="items" sticky-header height="300px">

      <template #cell(status)="data">
        <b-badge
            :style="{ color: 'white', backgroundColor: ( data.item.status?.color_code ?? '#7367f0' ) }"
            variant="info">{{ data.item.status?.name }}</b-badge>
      </template>

      <template #cell(name)="data">
        <span class="font-weight-bold cursor-pointer text-primary" @click="moveToDetails(data.item?.data?.id)">{{ data.item?.name }}</span>
      </template>

    </b-table>
    <template v-else>
      <div class="text-center m-1 mt-3 font-weight-bold">No Records Found</div>
    </template>
  </b-card>
</template>

  <script>
import {
  BCard,
  BAvatar,
  BBadge,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BDropdown,
  BDropdownItem,
  BButton,
  BForm,
  BModal,
  BSpinner,
  BCol,
  BRow,
  BFormDatepicker,
  BFormTextarea,
  BLink,
  BMedia,
  BMediaAside,
  BMediaBody,
  BCardText,
  BTable,
  VBTooltip,
} from "bootstrap-vue";
import { VueGoodTable } from "vue-good-table";
import Ripple from "vue-ripple-directive";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { mapGetters } from "vuex";
import { EventBus } from "@/helpers/event-bus";

export default {
  name: "AttendanceTable",
  components: {
    BForm,
    BButton,
    BCard,
    VueGoodTable,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    ValidationProvider,
    ValidationObserver,
    BModal,
    BSpinner,
    BCol,
    BRow,
    BFormDatepicker,
    BFormTextarea,
    BLink,
    BMedia,
    BMediaAside,
    BMediaBody,
    BCardText,
    BTable,
  },
  directives: {
    Ripple,
    "b-tooltip": VBTooltip,
  },
  data() {
    return {
      isLoading: false,
      currentDate: "",
      attendanceStatusSummary: {},
      attendanceStatus: [],
      filterWith: 'all',

      // filter
      items: [{ 
        name: "", 
        check_in: "No Data Found",
        check_out: "",
        status: "",
       }],
      fields: [
        { key: 'name', label: 'Name', sortable: false },
        { key: 'check_in', label: 'Check In' },
        { key: 'check_out', label: 'Check Out', sortable: false },
        { key: 'status', label: 'Status', sortable: false }
      ],
    };
  },

  computed: {
    ...mapGetters({
      permissions: "userModule/getPermissions",
    }),
  },

  async created() {
    try {
      const today = new Date();
      const formattedDate = today.toISOString().split("T")[0];

      this.currentDate = this.formatDate(formattedDate);

      this.loadItems();
    } catch (error) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Error",
          icon: "BellIcon",
          variant: "danger",
          text: error?.response?.data?.message,
        },
      });
    }
  },

  methods: {
    moveToDetails(id){
      this.$router.push({
        name: 'admin-attendance-details',
        params: { id },
      })
    },
    formatDate(value) {
      if (value) {
        return this.$moment(value).format("MMM Do YYYY");
      }
      return "Not Set";
    },

    filterByStatus(status) {

      this.isLoading = true
      this.filterWith = status;
      this.loadItems()
      
    },

    formatStatus(id){
      const status = this.attendanceStatus.find((status) => status.id === id);
      return status?.name;
    },

    goAttendance() {
      this.$router.push({ name: "admin-attendance" });
    },

    async getTodaysAttendance() {
      return await this.$api.get("api/dashboard/today-attendance?include=attendanceStatus&&status="+ this.filterWith);
    },
    async getTodaysAttendanceStatusCount() {
      return await this.$api.get("api/dashboard/today-attendance-status-count");
    },
    async getAttendanceStatus() {
      return await this.$api.get("api/dashboard/attendance-status/all");
    },
    async loadItems() {

      this.items = []

      const [todayAttendance, statusCount, attendanceStatus] = await Promise.all([
        this.getTodaysAttendance(),
        this.getTodaysAttendanceStatusCount(),
        this.getAttendanceStatus(),
      ]);

      this.attendanceStatus = attendanceStatus?.data?.data;

      this.attendanceStatusSummary = statusCount?.data;
      if (todayAttendance?.data?.data.length > 0) {

        this.items = todayAttendance?.data?.data.map((item) => {
          return {
            data: item,
            name: item?.user?.name,
            check_in: this.formatTime(item?.first_check_in),
            check_out: this.formatTime(item?.last_check_out),
            status: item?.attendanceStatus?.data,
          };
        });
      }

      this.isLoading = false

    },

    formatTime(value) {
      if (value) {
        return this.$moment(value, 'HH:mm:ss').format('LT')
      }
    },

    onShowPage(id) {
      this.$router.push({
        name: "admin-attendance-details",
        params: { id },
      });
    },
  },
};
</script>

  <style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
.table-custom-style-att {
  white-space: nowrap !important;
  min-height: 140px !important;
  tr,
  th,
  td {
    vertical-align: middle !important;
    text-align: center !important;
    font-size: 12px !important;
  }
}
.custom-font {
  font-size: 13px !important;
}
.attendance-spinner-parent {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
